import { LanguageVideoUpload } from "./LanguageVideo.Upload"
import { UserUpload } from "./User.Upload"
import { BulckBonusUpload } from "./BulckBonus.Upload"
import { BulckUserActiveUpload } from "./BulckUserActive.Upload"
import { AddBulckUserWelcomeBonusUpload } from "./AddBulckUserWelcomeBonus.Upload"
import { WithdrawPaymentInfoUpload } from "./WithdrawPaymentInfo.Upload"
import { WithdrawPaymentInfoNewUpload } from "./WithdrawPaymentInfonew.Upload"
import { ArticleUpload } from "./Article.Upload"
import { SiteCarouselSlideUpload } from "./SiteCarouselSlide.Upload"
import { ShopUpload } from "./Shop.Upload"
import { BulckUserActiveWithIntroUpload } from "./BulckUserActiveWithIntro.Upload"
import { BulckUserCouponPaymentActiveUpload } from "./BulckUserCouponPaymentActive.Upload"
import { PurchaseMarketingOrderidUpload } from "./PurchaseMarketingOrderid.Upload"
import { EduquestTestidUpload } from "./EduquestTestid.Upload"
import { EduquestCertificateidUpload } from "./EduquestCertificateid.Upload"
import {AppInstallationTaskAppidUpload} from "./AppInstallationTaskAppid.Upload"
import { BulckWithdrawStatusUpload } from "./BulckWithdrawStatus.Upload"
import { MicrotaskBulckUpload } from "./MicrotaskBulck.Upload"
import { MerchantIntentTesterLabelUpload } from "./MerchantIntentTesterLabel.Upload"



const Uploader = (resource, formdata) => {
    switch (resource) {
        case 'languagevideo': return LanguageVideoUpload(formdata);
        case 'shop': return ShopUpload(formdata);
        case 'user': return UserUpload(formdata);
        case 'sitecarouselslide': return SiteCarouselSlideUpload(formdata);
        case 'adminbulckbonusadd': return BulckBonusUpload(formdata);
        case 'adminbulckuseractive': return BulckUserActiveUpload(formdata);
        case 'bulckwithdrawstatusupdate': return BulckWithdrawStatusUpload(formdata);
        case 'adminbulckuseraddwelcomebonus': return AddBulckUserWelcomeBonusUpload(formdata);
        case 'purchasemarketingorderidupload': return PurchaseMarketingOrderidUpload(formdata);
        case 'eduquesttestidupload': return EduquestTestidUpload(formdata);
        case 'eduquestcertificateidupload': return EduquestCertificateidUpload(formdata);
        case 'appinstallationtaskappidupload': return AppInstallationTaskAppidUpload(formdata);

        case 'adminbulckmicrotaskactive': return MicrotaskBulckUpload(formdata);

        case 'article': return ArticleUpload(formdata);
        case 'article': return ArticleUpload(formdata);
        case 'adminbulckuseractivewithintro': return BulckUserActiveWithIntroUpload(formdata);
        case 'withdrawpaymentinfo': return WithdrawPaymentInfoUpload(formdata);
        case 'withdrawpaymentinfonew': return WithdrawPaymentInfoNewUpload(formdata);
        case 'adminbulckusercouponpaymentactive': return BulckUserCouponPaymentActiveUpload(formdata);
        case 'merchantintenttesterlabels': return MerchantIntentTesterLabelUpload(formdata);
        
        default: return formdata;
    }
}

export default Uploader